import {
	HttpClient,
	HttpHeaders,
	HttpParams,
	HttpResponse
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export type HttpVerb = 'get' | 'post' | 'put' | 'patch' | 'delete';

@Injectable({
	providedIn: 'root'
})
export class ApiService {
	private readonly webApiUrl: string;

	constructor(
		private http: HttpClient,
		@Inject('BASE_URL') baseUrl: string
	) {
		this.webApiUrl = `${baseUrl}/api`;
	}

	get<T = any>(endPoint: string): Observable<T>;
	get<T = any>(
		endPoint: string,
		options: { params: HttpParams }
	): Observable<T>;
	get<T = any>(
		endPoint: string,
		options: { headers: HttpHeaders }
	): Observable<T>;
	get<T = any>(
		endPoint: string,
		options: { headers: HttpHeaders; params: HttpParams }
	): Observable<T>;
	get<T = any>(
		endPoint: string,
		options: {
			headers?: HttpHeaders;
			params?: HttpParams;
			observe: 'response';
			responseType?: 'json';
		}
	): Observable<HttpResponse<T>>;
	get<T = any>(
		endPoint: string,
		options: {
			headers?: HttpHeaders;
			params?: HttpParams;
			observe: 'response';
			responseType: 'blob';
		}
	): Observable<HttpResponse<Blob>>;
	get(endPoint: string, options?: any): Observable<any> {
		return this.http.get(`${this.webApiUrl}/${endPoint}`, options);
	}

	post<T = any>(
		endPoint: string,
		body: any,
		options: { params: HttpParams }
	): Observable<T>;
	post<T = any>(
		endPoint: string,
		body: any,
		options: { headers: HttpHeaders }
	): Observable<T>;
	post<T = any>(
		endPoint: string,
		body: any,
		options: { headers: HttpHeaders; params: HttpParams }
	): Observable<T>;
	post<T = any>(
		endPoint: string,
		body: any,
		options?: { observe?: 'body'; responseType?: 'json' }
	): Observable<T>;
	post<T = any>(
		endPoint: string,
		body: any,
		options?: { observe?: 'response'; responseType?: 'json' }
	): Observable<HttpResponse<T>>;
	post(endPoint: string, body: any, options?: any): Observable<any> {
		return this.http.post(`${this.webApiUrl}/${endPoint}`, body, options);
	}

	put<T = any>(
		endPoint: string,
		body: any,
		options: { params: HttpParams }
	): Observable<T>;
	put<T = any>(
		endPoint: string,
		options: { headers: HttpHeaders }
	): Observable<T>;
	put<T = any>(
		endPoint: string,
		options: { headers: HttpHeaders; params: HttpParams }
	): Observable<T>;
	put<T = any>(
		endPoint: string,
		body: any,
		options?: { observe?: 'body'; responseType?: 'json' }
	): Observable<T>;
	put(endPoint: string, body: any, options?: any): Observable<any> {
		return this.http.put(`${this.webApiUrl}/${endPoint}`, body, options);
	}

	delete<T = void>(
		endPoint: string,
		body: any,
		options: { params: HttpParams }
	): Observable<T>;
	delete<T = void>(
		endPoint: string,
		options: { headers: HttpHeaders }
	): Observable<T>;
	delete<T = void>(
		endPoint: string,
		options: { headers: HttpHeaders; params: HttpParams }
	): Observable<T>;
	delete<T = void>(
		endPoint: string,
		options?: { observe: 'body'; responseType?: 'json' }
	): Observable<T>;
	delete(endPoint: string, options?: any): Observable<any> {
		return this.http.delete(`${this.webApiUrl}/${endPoint}`, options);
	}

	patch<T = any>(
		endPoint: string,
		body: any,
		options?: { observe: 'body'; responseType?: 'json' }
	): Observable<T>;
	patch(endPoint: string, body: any, options?: any): Observable<any> {
		return this.http.patch(`${this.webApiUrl}/${endPoint}`, body, options);
	}

	request<T = any>(
		method: HttpVerb,
		url: string,
		options?: { body?: any; headers?: HttpHeaders; params?: HttpParams }
	): Observable<T> {
		return this.http.request<T>(method, url, options);
	}
}
